import { useQueryClient } from 'react-query';
import api from '~/services/api';

export const useTelaPorCodigo = (): any => {
  const queryClient = useQueryClient();

  const fetchTelaPorCodigo = async (codTela: number) => {
    return queryClient.fetchQuery({
      queryKey: ['telaPorCodigo', codTela],
      queryFn: async () => {
        const { data } = await api.post('/tela-por-codigo', {
          cod_tela: codTela,
        });

        if (!data.success || !data.data) {
          throw new Error('Erro ao buscar dados da tela');
        }

        return data.data;
      },
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 30,
    });
  };

  return { fetchTelaPorCodigo };
};
